import { connect } from 'react-redux';
import { ParticipantViewModel } from 'stageclip-common';

import { DeleteAssetModalContent } from './DeleteAssetModalContent';
import { DeleteAssetModalProps } from './DeleteAssetModal';
import { callApi } from 'helpers/callApi/callApi';
import { normalizeParticipant } from 'api/normalizers/participantNormalizers';
import { createEditParticipant } from 'api/participants/participants.actions';
import { InternalActionTypes } from 'constants/actionTypes';

export const mapDispatchToProps = (
  dispatch: Function,
  { data: { asset, participantId }, close }: DeleteAssetModalProps,
) => ({
  removeAsset: () => {
    close();

    callApi<ParticipantViewModel>({
      action: () =>
        dispatch(
          createEditParticipant({
            id: participantId,
            // @ts-ignore
            virtualGraduation: { [asset]: null },
          }),
        ),
      onSuccess: ({ payload }) => {
        dispatch({
          type: InternalActionTypes.EventParticipantEdited,
          eventId: payload.eventId,
          result: normalizeParticipant(payload),
        });
      },
    });
  },
});

export const DeleteAssetModalContainer = connect(null, mapDispatchToProps)(DeleteAssetModalContent);
